import { DestroyRef, inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { STORAGE_KEYS } from '../constants/storage-keys.const';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly sessionChanges = new Subject<void>();
  readonly sessionChanges$ = this.sessionChanges.asObservable();

  get userInfoToken() {
    return sessionStorage.getItem(STORAGE_KEYS.ARP_TOKEN);
  }

  set userInfoToken(token: string | null) {
    const previous = this.userInfoToken;
    sessionStorage.setItem(STORAGE_KEYS.ARP_TOKEN, token || '');
    if (previous !== (token || '')) this.sessionChanges.next();
  }

  constructor() {
    // Remove credentials and expiry values cached by older app versions.
    sessionStorage.removeItem(STORAGE_KEYS.FIREBASE_TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.FIREBASE_AUTH_TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.FIREBASE_AUTH_TOKEN_EXPIRY);
    // TODO - add checking if embedded or standalone
    const interval = setInterval(
      () => {
        this.userInfoToken = null;
      },
      1000 * 60 * 60 * 8
    );
    inject(DestroyRef).onDestroy(() => clearInterval(interval));
  }
}
